import { render, staticRenderFns } from "./FixedColumn.vue?vue&type=template&id=7d83f059&"
import script from "./FixedColumn.vue?vue&type=script&lang=js&"
export * from "./FixedColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports